
import React, { Component } from 'react'
import IconButton from 'material-ui/IconButton'
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert'
import IconMenu from 'material-ui/IconMenu'
import Divider from 'material-ui/Divider'
import { Link } from 'react-router'
import {List, ListItem} from 'material-ui/List'
import Checkbox from 'material-ui/Checkbox';
import Avatar from 'material-ui/Avatar'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import ContentAdd from 'material-ui/svg-icons/content/add'

import StarsRating from './StarsRating'
import ShowDistance from './ShowDistance'


export default (o) => {
	return(
	(!o.repairman)? <div></div>
	:<div>
		<ListItem
			key={`repairmen-${o.id}`}
			style={{
				height: "80px"
			  , backgroundColor: "#FFF"
			  , overflow: 'hidden'
			  , paddingLeft:  (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "0" :"0px"
			  , marginLeft: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "" : "0"
			  , border: "1px solid #e1e3e2"
			  , margin: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "-2px 10px 0 10px" : "0 17px 0 10px"
			  , width: "100%"
			}}
			key={o.repairman._id}
			leftAvatar={
				<Checkbox
					onCheck={() => {
							let newID = new Date().valueOf().toString() +'-'+ Math.random().toString(36).substr(2, 8)
							o.PROJECT_REPAIRMAN_CHECK({
								_id: newID
							  , repairmanID: o.repairman._id
							  , projectID: o.projectID
							  , status: "new"
							  , type: "quote"
							})
						}
					}
				/>
			}
			primaryText={
				<div>
					<p
						className="main-text"
						style={{
							position: "relative"
						  , maxWidth: "30%"
						  , fontSize: "14px"
						  , fontWeight: "bold"
						  , marginTop: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "-15px": "2px"
						  , marginLeft: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "2px" : "6px"
						  , marginBottom: "0px"
						  , textOverflow: "ellipsis"
						  , whiteSpace: "nowrap"
						  , overflow: "hidden"
						}}
					>
						{`${o.repairman.firstName}`}
					</p>
					<div
						className="secondary-text"
						style={{
							float: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "left" : "right"
						  , width: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "100vw" : "34.7%"
						  , marginTop: "-1px"
						  , overflow: "hidden"
						}}
					>
						{(o.repairman.categories && o.repairman.categories.length)?
							<p style={{
									fontSize: "14px"
								  , position: "relative"
								  , paddingLeft: "0px"
								  , margin: '0'
								  , color: "#000000"
								  , top:"-1px"
								  , height: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "32px" : "auto"
								  , overflow: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "hidden" : "auto"
								  , left: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "0" : "40px"
								}}
							>
								{o.repairman.categories.map((category, indx, arr) =>
									(indx == 0 || o.repairman.id)?
										category
										: (arr && indx == arr.length -1)?
											` and ${category}`
											: `, ${category}`
								)}
							</p>
							: <p style={{fontSize: "12px", clear: "left", position: "relative", paddingLeft: "0px", margin: '0', color: "#000000"}}>No categories</p>
						}
					</div>
				</div>

			}
			secondaryText={
				(typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?
					""
					:<div
						style={{
							marginTop: "10px"
						}}
					>
						<StarsRating
							className="rating"
							style={{
								display: "inline-block"
							  , verticalAlign: "middle"
							  , marginLeft: "6px"
							}}
							size = "15px"
							color = "#808080"
							key={`${o.repairman._id}-${o.repairman.rating}`}
							value = {(o.repairman.rating)?o.repairman.rating:"0"}
						/>
						{(o.property._id && o.property._id != 'All')?
							<ShowDistance
								style={{
									display: "inline-block"
								  , color: "#3cd2ae"
								  , fontSize: "12px"
								  , verticalAlign: "middle"
								  , marginLeft: "10px"
								  , marginTop: "-7px"
								}}
								first={
									(o.repairman.cors && o.repairman.cors.lat)?
										o.repairman.cors
										: o.repairman.address.replace('\n', '+')
								}
								key={o.property._id}
								loaderSize={0.25}
								second={
									(
										o.property.cors
										&& o.property.cors.lat
									)?
										o.property.cors
										:
											(o.property)?
												o.property.address.replace('\n', '+')
												: "LOADING"
								}
								callBack={(newCors, type) =>{
									(type == "first")?
										o.docUpd({
											_id: o.repairman._id
										  , cors: newCors
										})
										:
										o.docUpd({
											_id: o.property._id
										  , cors: newCors
										})}
								}
							/>
							:""
						}
					</div>
			}
			secondaryTextLines={2}
			className="list-hover"
		>
		{(typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?
			<div
				className="distance"
				style={{float: "right", color: "#000", fontSize: "14px"}}>
				<br/>
				{(o.property._id && o.property._id != 'All')?
					<ShowDistance
						style={{
							float: 'right'
						  , marginTop: "7px"
						  , marginLeft: "10px"
						}}
						first={
							(o.repairman.cors && o.repairman.cors.lat)?
								o.repairman.cors
								: o.repairman.address.replace('\n', '+')
						}
						key={o.property._id}
						loaderSize={0.25}
						second={
							(
								o.property.cors
								&& o.property.cors.lat
							)?
								o.property.cors
								:
									(o.property)?
										o.property.address.replace('\n', '+')
										: "LOADING"
						}
						callBack={(newCors, type) =>{
							(type == "first")?
								o.docUpd({
									_id: o.repairman._id
								  , cors: newCors
								})
								:
								o.docUpd({
									_id: o.property._id
								  , cors: newCors
								})}
						}
					/>
					:""
				}
				<StarsRating
					className="rating"
					style={{
						float: "right"
					  , marginTop:"-7px"
					}}
					size = {(typeof global.md.phone() == 'string')? "13pt" : "12px"}
					color = "#808080"
					key={`${o.repairman._id}-${o.repairman.rating}`}
					value = {(o.repairman.rating)?o.repairman.rating:"0"}
				/>
			</div>
		: "" }
		</ListItem>
		{(typeof global.md.phone() == 'string')? <Divider style={{padding: "1"}} />: ""}
	</div>
)}



// WEBPACK FOOTER //
// ./src/components/RepairmenSelectCard.js